import React from "react";

export const RadioButton = ({
  isSelected,
  children,
  ...props
}: {
  isSelected: boolean;
  children: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button
      className={`${
        isSelected ? "bg-gray-400" : "hover:bg-gray-400"
      } text-sm hover:bg-gray-400 text-gray-800 font-semibold py-2 mr-1 px-4 rounded`}
      {...props}
    >
      {children}
    </button>
  );
};
